<template>
  <v-card v-if="user && presentation"
          class="CL__PresentationCard flex-grow-1 d-flex flex-column">
    <presentation-thumbnail :presentation="presentation">
    </presentation-thumbnail>

    <v-divider></v-divider>

    <v-card-title class="font-weight-regular py-2 pb-0 px-2">
      {{ presentation.name }}
    </v-card-title>
    <v-card-text v-if="presentation.is_new || presentation.is_featured"
                 class="d-flex px-2 py-1 font-weight-bold text-body-2 text-uppercase ">
      <v-chip v-if="presentation.is_new"
              color="success"
              label
              x-small
              class="mr-2">
        New
      </v-chip>
      <v-chip v-if="presentation.is_featured"
              color="info"
              label
              x-small>
        Featured
      </v-chip>
    </v-card-text>

    <presentation-for-internal-use-only :presentation="presentation">
    </presentation-for-internal-use-only>

    <v-card-actions>
      <presentation-card-actions :presentation="presentation">
      </presentation-card-actions>
    </v-card-actions>
  </v-card>
</template>
<script>
import {mapGetters} from 'vuex';
import OpenPresentationMenuList from './OpenPresentationMenuList';
import PresentationCardActions from './PresentationCardActions';
import PresentationThumbnail from './PresentationThumbnail';
import PresentationForInternalUseOnly from "./PresentationForInternalUseOnly";

export default {
  components: {PresentationForInternalUseOnly, PresentationThumbnail, PresentationCardActions, OpenPresentationMenuList},
  props: {
    presentation: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters([
      'team',
      'user',
    ]),
    ...mapGetters('content', [
      'bookmarks',
      'bookmarkedPresentations',
      'liveMode',
    ]),
    canBePresented() {
      return !!this.presentation.settings.can_be_presented_by_user;
    },
    canBeOpened() {
      if (this.isHTML) { // MLD-2254
        return this.team.is_content_domain_enabled
            && this.presentation.settings.can_user_use_cdn;
      }
      return !this.isHTML;
    },
    isURL() {
      return this.presentation.type_url;
    },
    isHTML() {
      return this.presentation.type_html;
    },
  },
  methods: {}
}
</script>
